import { Injectable, signal } from '@angular/core';

export interface Toast {
    heading?: string;
    message?: string;
    delay?: number;
    toastType?: string;
}

export const ToastType = {
    standard: 'standard',
    success: 'success',
    danger: 'danger',
    info: 'info',
    warning: 'warning',
    primary: 'primary',
    secondary: 'secondary',
};

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    toasts = signal<Toast[]>([]);

    show(toast: Toast) {
        this.toasts.update((toasts) => [...toasts, toast]);
    }

    remove(toast: Toast) {
        this.toasts.update((toasts) => toasts.filter((t) => t != toast));
    }

    // show(message: string, heading?: string, delay?: number, toastType?: string) {
    //     this.toasts.update((toasts) => [...toasts, { heading, message, delay, toastType }]);
    // }

    // show(toast: Toast) {
    //     this.toasts.push(toast);
    // }

    // remove(toast: Toast) {
    //     this.toasts = this.toasts.filter((t) => t != toast);
    // }

    // clear() {
    //     this.toasts.splice(0, this.toasts.length);
    // }
}
